import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';

interface Props {
    name: string;
    imageUrl?: string;
    message?: string;
}

function ProductCard({ name, imageUrl, message }: Props) {
    return (
        <>
            <Card>
                {imageUrl && (
                    <ImageWrap>
                        <ProductImage src={imageUrl} width={200} height={200} alt={name} />
                    </ImageWrap>
                )}
                <Text size='title' fontWeight='bold' align='center'>{name}</Text>
            </Card>
            {message?.trim() && <Message color={colors.textSecondary}>{message}</Message>}
        </>
    );
}

const Card = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-4);
    padding: var(--spacing-6);
    border-radius: 8px;
    background: ${colors.white};
`;

const ImageWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
`;

const ProductImage = styled(Image)`
    border-radius: 8px;
    object-fit: contain;
`;

const Message = styled(Text)`
    width: 100%;
    padding: var(--spacing-4);
    border-radius: 8px;
    background: ${colors.white};
    word-break: break-word;
`;

export default ProductCard;
